import React, { useState, useEffect, useMemo } from 'react';
import { useHistory, useParams } from "react-router-dom";

import T, { Translate } from '../../i18n/i18n';
import * as Tag from './TableDetail.styles';
import { getTableDetails, denouceTable, askToJoinTable } from '../../../services/tables';
import { FormatDate } from '../../../services/dates';
import ResourceImage from '../../ResourceImage/ResourceImage';
import { useSelector } from 'react-redux';

const reasons = ["boring", "span", "content", "racism", "disrespect", "other"];

export default () => {

    const history = useHistory();
    const params = useParams();

    const playerId = useSelector(state => state.authState.id);
    
    const [tabledata, setTableData] = useState(null);
    const [showExtraActions, setShowExtraActions] = useState(false);
    const [showConfirmAction, setShowConfirmAction] = useState(false);
    const [showDenounceForm, setShowDenounceForm] = useState(false);
    const [denounceReason, setDenounceReason] = useState("");
    const [denounceNote, setDenounceNote] = useState("");

    const handleBack = () => {
        history.goBack();
    };

    const handleAskToJoin = async () => {
        await askToJoinTable(params.id);
        history.push('/home/messages');
    };

    const handleGoToProfile = (id) => {
        history.push(`/home/user/${id}`);
    };

    const handleSendDenounce = async () => {
        let res = await denouceTable(params.id, denounceReason, denounceNote);
        history.goBack();
    }

    const performAction = () => {
        switch(showConfirmAction) {
            case 'denounce':
                setShowDenounceForm(true);
                break;
            default:
                console.log('Do nothing');
                break;
        }

        closeExtra();
    }

    const closeExtra = () => {
        setShowConfirmAction(false); 
        setShowExtraActions(false)
    }

    const participantOf = useMemo(() => {
        if (!tabledata) {
            return false;
        }
        const players = [tabledata.gm, ...tabledata.players];
        return players.some(p => p.id === playerId);
    },[tabledata]);

    const reasonsOptions = useMemo(()=>{
        return [...reasons].map(r => ({
            reason: r,
            rnd: Math.random()
        })).sort((a,b) => a.rnd > b.rnd ? -1 : 1).map(i => <option key={i.reason} value={i.reason}>{Translate(`denounces.${i.reason}`)}</option>);
    },[]);

    useEffect(()=>{
        let setState = true;

        (async () => {
            let data = await getTableDetails(params.id);

            if (setState) {
                setTableData(data.payload && data.payload.name ? data.payload : null);
            }
        })();

        return () => {setState = false;}
    }, []);


    return <>
        <Tag.HeaderRow>
            <Tag.ButtonBack color="#aaa" onClick={handleBack} />
            <Tag.Title><T value="tabledetail.title" /></Tag.Title>
            {showDenounceForm ? <>
                <Tag.Label className="compact"><T value="denounces.reason" /></Tag.Label>
                <Tag.Select value={denounceReason} onChange={(e)=>setDenounceReason(e.target.value)}>
                    <option value="">{Translate()}</option>
                    {reasonsOptions}
                </Tag.Select>
                <Tag.Label className="compact"><T value="denounces.note" /></Tag.Label>
                <Tag.Input style={{width:"150px",minWidth:"150px"}} value={denounceNote} onChange={(e)=>setDenounceNote(e.target.value)} />
                <Tag.Button color="#f33" onClick={handleSendDenounce}><T value="send" /></Tag.Button>
                <Tag.Button color="#888" onClick={()=>setShowDenounceForm(false)}><T value="cancel" /></Tag.Button>
            </> : <>
                {!showExtraActions && !showConfirmAction ? <>
                    {participantOf ? null : <Tag.Button color="#0c0" onClick={handleAskToJoin}><T value="tabledetail.ask" /></Tag.Button>}
                    <Tag.ButtonIcon color="#be5cde" onClick={()=>setShowExtraActions(true)} icon="\F01D8" title={Translate("tabledetail.more")} />
                </> : null }
                {showExtraActions && !showConfirmAction ? <>
                    <Tag.Button color="#B0B0B0" onClick={() => setShowConfirmAction("denounce")}><T value="tabledetail.denouce" /></Tag.Button>
                    <Tag.Button color="#06f" onClick={() => setShowExtraActions(false)}><T value="cancel" /></Tag.Button>
                </> : null }
                {showConfirmAction ? <>
                    <Tag.ConfirmMessage><T value='tabledetail.confirm-denouce' /></Tag.ConfirmMessage>
                    <Tag.Button color="#f33" onClick={() => performAction()}><T value="yes" /></Tag.Button>
                    <Tag.Button color="#0c0" onClick={() => closeExtra()}><T value="no" /></Tag.Button>
                </> : null }
            </>}
        </Tag.HeaderRow>

        {tabledata ? <Tag.Container>
            <Tag.Row align="center">
                <Tag.Image>{tabledata.thumbnail ? <ResourceImage resourceId={tabledata.thumbnail} /> : null}</Tag.Image>
                <Tag.Name>{tabledata.name}</Tag.Name>
            </Tag.Row>
            <Tag.Row>
                <Tag.Column>
                    <Tag.Row>
                        <Tag.Label><T value="tabledetail.next" /></Tag.Label>
                        {tabledata.next ? <Tag.Value>{FormatDate(tabledata.next)}</Tag.Value> : <Tag.ValueOff><T value="tabledetail.next-none" /></Tag.ValueOff>}
                    </Tag.Row>
                    <Tag.Row>
                        <Tag.Label><T value="tabledetail.frequency" /></Tag.Label>
                        {tabledata.frequency ? <Tag.Value>{Translate(`tabledetail.frequency-${tabledata.frequency}`)}</Tag.Value> : <Tag.ValueOff><T value="tabledetail.frequency-none" /></Tag.ValueOff>}
                    </Tag.Row>
                    <Tag.Row>
                        <Tag.Label><T value="tabledetail.time" /></Tag.Label>
                        {tabledata.timeFrom && tabledata.timeTo ? <Tag.Value>{Translate("tabledetail.time-value").replace("$1", tabledata.timeFrom).replace("$2", tabledata.timeTo)}</Tag.Value> : <Tag.ValueOff><T value="tabledetail.time-none" /></Tag.ValueOff>}
                    </Tag.Row>
                    <Tag.Row>
                        <Tag.Label><T value="tabledetail.positions" /></Tag.Label>
                        {tabledata.playersMax ? <Tag.Value>{Translate("tabledetail.positions-value").replace("$1", tabledata.playersMax - (tabledata.players ? tabledata.players.length : 0) ?? 0).replace("$2", tabledata.playersMax)}</Tag.Value> : <Tag.ValueOff><T value="tabledetail.positions-none" /></Tag.ValueOff>}
                    </Tag.Row>
                    <Tag.Row>
                        <Tag.Label><T value="tabledetail.gamesystem" /></Tag.Label>
                        {tabledata.system ? <Tag.Value>{tabledata.system}</Tag.Value> : <Tag.ValueOff><T value="tabledetail.gamesystem-none" /></Tag.ValueOff>}
                    </Tag.Row>
                    <Tag.Row>
                        <Tag.Label><T value="tabledetail.gm" /></Tag.Label>
                        {tabledata.gm ? <Tag.Value>{tabledata.gm.name}</Tag.Value> : <Tag.ValueOff><T value="tabledetail.gm-none" /></Tag.ValueOff>}
                    </Tag.Row>
                    <Tag.TagGroup>
                        <Tag.Label><T value="tabledetail.content" /></Tag.Label>
                        <Tag.Row>
                            {tabledata.content && tabledata.content.length ? tabledata.content.map((t,i) => <Tag.Tag key={i} className="content">{t[Translate('lang')]}</Tag.Tag>) : <Tag.ValueOff><T value="tabledetail.content-none" /></Tag.ValueOff>}
                        </Tag.Row>
                    </Tag.TagGroup>
                    <Tag.TagGroup>
                        <Tag.Label><T value="tabledetail.tools" /></Tag.Label>
                        <Tag.Row>
                            {tabledata.tools && tabledata.tools.length ? tabledata.tools.map((t,i) => <Tag.Tag key={i} className="tools">{t[Translate('lang')]}</Tag.Tag>) : <Tag.ValueOff><T value="tabledetail.tools-none" /></Tag.ValueOff>}
                        </Tag.Row>
                    </Tag.TagGroup>
                    <Tag.TagGroup>
                        <Tag.Label><T value="tabledetail.players" /></Tag.Label>
                        <Tag.Column>
                            {tabledata.gm ? <Tag.Row align="center" className="hasLink" onClick={() => handleGoToProfile(tabledata.gm.id)}>
                                <Tag.PlayerIcon color={tabledata.gm.color} fgColor={tabledata.gm.fgColor}>{tabledata.gm.name.substring(0,1).toUpperCase()}</Tag.PlayerIcon>
                                <Tag.PlayerName>{tabledata.gm.name}</Tag.PlayerName>
                                <Tag.PlayerGMIcon />
                            </Tag.Row> : <Tag.Row align="center">
                                <Tag.PlayerIcon color="#444"></Tag.PlayerIcon>
                                <Tag.PlayerNameOff><T value="tabledetail.players-opened" /></Tag.PlayerNameOff>
                                <Tag.PlayerGMIcon />
                            </Tag.Row>}
                            {tabledata.players && tabledata.players.length ? 
                                tabledata.players.map((p, i) => <Tag.Row key={i} align="center" className="hasLink" onClick={() => handleGoToProfile(p.id)}>
                                    <Tag.PlayerIcon color={p.color} fgColor={p.fgColor}>{p.name.substring(0,1).toUpperCase()}</Tag.PlayerIcon>
                                    <Tag.PlayerName>{p.name}</Tag.PlayerName>
                                </Tag.Row>) 
                            : null}
                            {tabledata.playersMax ? 
                                Array(Math.max(tabledata.playersMax - (tabledata.players ? tabledata.players.length : 0), 0)).fill("").map((p, i) => <Tag.Row key={i} align="center">
                                    <Tag.PlayerIcon color="#444"></Tag.PlayerIcon>
                                    <Tag.PlayerNameOff><T value="tabledetail.players-opened" /></Tag.PlayerNameOff>
                                </Tag.Row>) 
                            : null}
                        </Tag.Column>
                    </Tag.TagGroup>
                </Tag.Column>
                <Tag.Column>
                    <Tag.Row>
                        <Tag.Label><T value="tabledetail.description" /></Tag.Label>
                        {tabledata.description ? <Tag.Value>{tabledata.description}</Tag.Value> : <Tag.ValueOff><T value="tabledetail.description-none" /></Tag.ValueOff>}
                    </Tag.Row>
                </Tag.Column>
            </Tag.Row>
        </Tag.Container> : null}
    </>
};